import { PAGES } from "@dune/types";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetDuneTasks } from "../../api/queries/dashboard.queries";
import { useMe } from "../../api/queries/users.queries";
import ErrorBoundary from "../../component/common/ErrorBoundary";
import { DashboardHeader } from "../broker-dashboard/components/DashboardHeader";
import { TasksSection } from "../broker-dashboard/components/TasksSection";
import { DocumentsSection } from "./components/DocumentsSection";

const DuneDashboard: React.FC = () => {
	const navigate = useNavigate();
	const { me } = useMe();
	const duneTasksQuery = useGetDuneTasks();
	const handleNewProject = () => {
		navigate(PAGES.PROJECTS.create);
	};

	return (
		<div className="h-screen bg-white overflow-hidden flex flex-col rounded-lg border">
			<ErrorBoundary fallbackMessage="Erreur lors du chargement du tableau de bord">
				<div className="flex-shrink-0 p-6 pb-4">
					<DashboardHeader
						firstName={me?.firstname || ""}
						onNewProject={handleNewProject}
					/>
				</div>
				<div className="flex-1 px-6 pb-6 overflow-hidden">
					<div className="h-full flex flex-row gap-6">
						<div className="col-span-2 min-h-0 w-3/4">
							<DocumentsSection />
						</div>
						<div className="col-span-2 min-h-0 w-1/4">
							<TasksSection
								tasksData={duneTasksQuery.data}
								isLoading={duneTasksQuery.isLoading}
								error={duneTasksQuery.error}
							/>
						</div>
					</div>
				</div>
			</ErrorBoundary>
		</div>
	);
};

export default DuneDashboard;
